import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { withTranslation } from 'react-i18next';
import { Grid, Icon, Menu, Message } from 'semantic-ui-react';
import { Loading } from 'react-lib/dist/components-es';
import { lmsCoursesActions } from '../behavior/lmsCourses';
import { useOnce } from 'react-lib/dist/hooks-es';

const RequiredLmsCoursesPage = ({ getRequiredLmsCourses, requiredLmsCourses, t, isLoading }) => {
  useOnce(() => {
    if (!requiredLmsCourses) getRequiredLmsCourses();
  });

  const getCourse = course => (
    <Menu.Item key={course.details.code}>
      <a
        href={`${window.REACT_APP_LMS_PAGE_SEARCH_KEYWORD}${course.details.code}`}
        target="_blank"
      >
        {course.details.title}
      </a>
      {course.isAboutToExpire ? t('required.lms.courses.page.is.about.to.expire') : null}
    </Menu.Item>
  );

  let requiredLmsCoursesRemaining = requiredLmsCourses && requiredLmsCourses.length > 0;

  return (
    <Grid stackable className="centered withTopMargin">
      <Grid.Row>
        <h3>{t('required.lms.courses.page.title')}</h3>
      </Grid.Row>
      <Grid.Row>
        <Grid.Column computer={6} tablet={10}>
          {requiredLmsCoursesRemaining && (
            <>
              <Message color={'yellow'}>
                <Icon name="warning sign" />
                {t('required.lms.courses.page.warning.todo.info')}
              </Message>
              <Message color={'yellow'}>
                <Icon name="warning sign" />
                {t('required.lms.courses.page.warning.sync.info')}
              </Message>
            </>
          )}
          {!isLoading && requiredLmsCourses && requiredLmsCourses.length == 0 && (
            <Message color="green">
              <Icon name="warning sign" />
              {t('required.lms.courses.page.success.no.courses')}
            </Message>
          )}
        </Grid.Column>
      </Grid.Row>
      <Grid.Row>
        <Grid.Column computer={6} tablet={10}>
          <Loading isLoading={isLoading} />
          {requiredLmsCoursesRemaining && (
            <Menu vertical fluid>
              {requiredLmsCourses.map(c => getCourse(c))}
            </Menu>
          )}
        </Grid.Column>
      </Grid.Row>
    </Grid>
  );
};

const mapStateToProps = state => ({
  ...state.lmsCourses
});

const mapDispatchToProps = dispatch => ({
  getRequiredLmsCourses: () => dispatch(lmsCoursesActions.getRequiredLmsCourses())
});

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withTranslation()
)(RequiredLmsCoursesPage);
